import { createEvent, createStore } from 'effector';
import { SidebarContextProps } from './context/model';

export const open = createEvent<SidebarContextProps>();
export const close = createEvent();

export const $panel = createStore<SidebarContextProps | null>(null)
  .on(open, (_, props) => props)
  .on(close, () => null);
